import { createIcon } from '@chakra-ui/react';

export const CheckBack = createIcon({
  displayName: 'CheckBack',
  viewBox: '0 0 24 13.696',
  path: (
    <g id="Check_Back" data-name="Check Back" transform="translate(-37 11)">
      <path
        id="frame"
        d="M24.5,15.021a.588.588,0,0,0-.168-.412.561.561,0,0,0-.4-.169H1.071a.561.561,0,0,0-.4.169.588.588,0,0,0-.168.412V27.555a.588.588,0,0,0,.168.412.561.561,0,0,0,.4.169H23.929a.574.574,0,0,0,.568-.581V15.021ZM23.357,26.974H1.643V17.665H23.357Z"
        transform="translate(36.5 -25.44)"
        fill="currentColor"
      />
      <path
        id="signature"
        d="M5.933,1.982h-.2a.552.552,0,0,1-.175-.031,2.355,2.355,0,0,1-.35-.164,1.5,1.5,0,0,0-.381-.156,1.031,1.031,0,0,0-.24,0h-.2c-.274.031-.537.07-.8.094a1.384,1.384,0,0,1-.343,0,.328.328,0,0,1-.11-.051.157.157,0,0,1-.05-.082.736.736,0,0,1-.072-.324h0c.251-.164.5-.339.739-.515h0A.252.252,0,0,0,3.845.5.256.256,0,0,0,3.552.289,1.78,1.78,0,0,0,3.1.441a1.119,1.119,0,0,0-.381.324c-.183.1-.381.207-.564.3s-.446.211-.659.292a5.166,5.166,0,0,1-.636.207,1.043,1.043,0,0,1-.21.019h0A.738.738,0,0,1,.79,1.167a9.388,9.388,0,0,1,.979-1.1s0,0,0-.043-.03-.031-.042,0a3.143,3.143,0,0,0-.678.261A2.714,2.714,0,0,0,.394.765a1.515,1.515,0,0,0-.286.39.864.864,0,0,0-.091.589,1.063,1.063,0,0,0,.053.168.519.519,0,0,0,.11.164A.664.664,0,0,0,.5,2.27a1.009,1.009,0,0,0,.526,0,4.6,4.6,0,0,0,1.463-.663l.141-.094a1.249,1.249,0,0,0,.1.25A.59.59,0,0,0,2.927,2a.838.838,0,0,0,.263.105,1.727,1.727,0,0,0,.453,0c.286-.043.537-.113.8-.156A1.572,1.572,0,0,1,4.8,1.912a1.722,1.722,0,0,1,.381.113,2.25,2.25,0,0,0,.381.133.551.551,0,0,0,.229.023h.206c.533-.051,1.07-.136,1.592-.226.023,0,.03-.023.03-.043s-.038-.031-.057,0c-.56,0-1.1.051-1.619.07Z"
        transform="translate(39.292 0.48) rotate(-90)"
        fill="currentColor"
      />
      <line
        id="Line_159"
        data-name="Line 159"
        y1="4.039"
        transform="translate(43.8 -4.568)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="1.5"
      />
    </g>
  ),
});
